import Role from "../../entities/role";

/**
 * Role actions
 *
 * Call order:
 *
 * ROLE_SAVE_QUEUE:	adds the item to the save queue
 * --> ROLE_SAVE:	modifies the state
 * --> ROLE_SAVE_SUCCESS: if all went well
 * --> ROLE_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail ROLE_SAVE_QUEUE is during the call to ROLE_SAVE,
 * as adding an item to the queue should never fail.
 */

export const ROLE_FETCH_ONE_QUEUE: any = 'ROLE_FETCH_ONE_QUEUE';
export const ROLE_FETCH_SUCCESS: any = 'ROLE_FETCH_SUCCESS';
export const ROLE_FETCH_FAILURE: any = 'ROLE_FETCH_FAILURE';
export const ROLE_FETCH_ONE_SUCCESS: any = 'ROLE_FETCH_ONE_SUCCESS';
export const ROLE_FETCH_ONE_FAILURE: any = 'ROLE_FETCH_ONE_FAILURE';

export const ROLE_SAVE: any = 'ROLE_SAVE';
export const ROLE_SAVE_QUEUE: any = 'ROLE_SAVE_QUEUE';
export const ROLE_SAVE_SUCCESS: any = 'ROLE_SAVE_SUCCESS';
export const ROLE_SAVE_FAILURE: any = 'ROLE_SAVE_FAILURE';

export const ROLE_SAVE_MANY: any = 'ROLE_SAVE_MANY';
export const ROLE_SAVE_MANY_QUEUE: any = 'ROLE_SAVE_MANY_QUEUE';
export const ROLE_SAVE_MANY_SUCCESS: any = 'ROLE_SAVE_MANY_SUCCESS';
export const ROLE_SAVE_MANY_FAILURE: any = 'ROLE_SAVE_MANY_FAILURE';

export const ROLE_REMOVE: any = 'ROLE_REMOVE';
export const ROLE_REMOVE_QUEUE: any = 'ROLE_REMOVE_QUEUE';
export const ROLE_REMOVE_SUCCESS: any = 'ROLE_REMOVE_SUCCESS';
export const ROLE_REMOVE_FAILURE: any = 'ROLE_REMOVE_FAILURE';

export const ROLE_RESTORE: any = 'ROLE_RESTORE';
export const ROLE_RESTORE_QUEUE: any = 'ROLE_RESTORE_QUEUE';
export const ROLE_RESTORE_SUCCESS: any = 'ROLE_RESTORE_SUCCESS';
export const ROLE_RESTORE_FAILURE: any = 'ROLE_RESTORE_FAILURE';

export const ROLE_RESTORE_MANY: any = 'ROLE_RESTORE_MANY';
export const ROLE_REMOVE_MANY: any = 'ROLE_REMOVE_MANY';

/* Fetch actions */
export const fetchRoleSuccess = (roles: Role[], partial: boolean, lastFetch: number) => ({type: ROLE_FETCH_SUCCESS, roles, partial, lastFetch});
export const fetchRoleFailure = (err: any) => {
		console.error('RoleAction: fetchRoleFailure', err);
		return {type: ROLE_FETCH_FAILURE, err};
};
export const fetchOneRoleQueue = (roleId: string) => ({type: ROLE_FETCH_ONE_QUEUE, roleId});
export const fetchOneRoleSuccess = (role: Role) => ({type: ROLE_FETCH_ONE_SUCCESS, role});
export const fetchOneRoleFailure = (id: string, err: any) => {
		console.error('RoleAction: fetchOneRoleFailure', err);
		return {type: ROLE_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveRole = (role: Role) => {
    // console.debug('⮂ ROLE_SAVE action', role?.id);
    return {type: ROLE_SAVE, role};
}
export const saveRoleQueue = (role: Role, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ ROLE_SAVE_QUEUE action', role?.id);
    return {type: ROLE_SAVE_QUEUE, role, onQueued};
}
export const saveRoleSuccess = (role: Role) => {
    // console.debug('⮂ ROLE_SAVE_SUCCESS action', role?.id);
    return {type: ROLE_SAVE_SUCCESS, role};
}
export const saveRoleFailure = (role: Role, status: number, message: string) => {
    console.warn(`⮂ ROLE_SAVE_FAILURE error saving role: HTTP ${status}: ${message}`, role?.id);
    return {type: ROLE_SAVE_FAILURE, role, status, message};
};

/* SaveMany actions */
export const saveManyRoles = (roles: Role[]) => {
    // console.debug('⮂ ROLE_SAVE_MANY action', roles?.map(role => role?.id).join(','));
    return {type: ROLE_SAVE_MANY, roles};
}
export const saveManyRolesQueue = (roles: Role[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ ROLE_SAVE_MANY_QUEUE action', roles?.map(role => role.id).join(','));
    return {type: ROLE_SAVE_MANY_QUEUE, roles, onQueued};
}

export const saveManyRolesSuccess = (roles: Role[]) => {
    // console.debug('⮂ ROLE_SAVE_MANY_SUCCESS action', roles?.map(role => role.id).join(','));
    return {type: ROLE_SAVE_MANY_SUCCESS, roles};
}
export const saveManyRolesFailure = (roles: Role[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_ROLES_FAILURE Error saving roles: HTTP ${status}: ${message}`, roles?.map(role => role.id).join(','));
		return {type: ROLE_SAVE_MANY_FAILURE, roles, status, message};
};

/* Remove actions */
export const removeRole = (role: Role) => ({ type: ROLE_REMOVE, role });
export const removeRoleQueue = (role: Role) => ({ type: ROLE_REMOVE_QUEUE, role });
export const removeRoleSuccess = (role: Role) => ({ type: ROLE_REMOVE_SUCCESS, role });
export const removeRoleFailure = (role: Role, status: number, message: string) => {
	console.error(`Redux: removeRoleFailure Error removing role: HTTP ${status}: ${message}`);
	return ({ type: ROLE_REMOVE_FAILURE, role, status, message });
};

/* Restore actions */
export const restoreRole = (role: Role) => ({ type: ROLE_RESTORE, role });
export const restoreRoleQueue = (role: Role) => ({ type: ROLE_RESTORE_QUEUE, role });
export const restoreRoleSuccess = (role: Role) => ({ type: ROLE_RESTORE_SUCCESS, role });
export const restoreRoleFailure = (role: Role, status: number, message: string) => {
	console.error(`Redux: restoreRoleFailure Error restoring role: HTTP ${status}: ${message}`);
	return ({ type: ROLE_RESTORE_FAILURE, role, status, message });
};

/* RestoreMany actions */
export const restoreManyRoles = (roles: Role[]) => ({ type: ROLE_RESTORE_MANY, roles });

/* RemoveMany actions */
export const removeManyRoles = (roles: Role[]) => ({ type: ROLE_REMOVE_MANY, roles });